import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';
import { Link } from 'react-router-dom';

export default function LatestGrid() {
  const latestArticles = articles.filter((a) => !a.isFeatured).slice(0, 6);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row lg:items-start gap-4 mb-10 md:mb-14">
          <div className="flex-1">
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-black text-foreground-950 leading-tight">
              最新爆料
            </h2>
            <p className="font-heading text-lg md:text-xl italic text-foreground-400 mt-1 font-light">
              每日更新黑料资讯
            </p>
          </div>
          <div className="lg:w-64">
            <p className="text-sm text-foreground-500 leading-relaxed">
              实时追踪网红圈最新动态，第一时间报道塌房事件与争议话题。
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {latestArticles.map((article, index) => (
            <ArticleCard
              key={article.id}
              {...article}
              variant={index === 0 ? 'featured' : 'default'}
            />
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/category/chigua-baoliao"
            className="inline-flex items-center gap-2 px-8 py-3 bg-foreground-950 hover:bg-foreground-800 text-background-50 rounded-full font-label text-sm transition-all duration-300 whitespace-nowrap"
          >
            查看更多爆料
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}